import { Box, CircularProgress, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const StyledLoadingContainer = styled(Box)(() => ({
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export function TokenLoading() {
  return (
    <StyledLoadingContainer>
      <Typography variant="subtitle1" fontWeight={600} marginBottom={5}>
        Processing the script...
      </Typography>
      <CircularProgress color="secondary" thickness={4.5} size={42} />
    </StyledLoadingContainer>
  );
}
